import { useEffect } from 'react';

/**
 * Custom hook to detect clicks outside a specified element.
 *
 * @param {React.RefObject<HTMLElement>} ref - The ref object attached to the element to monitor.
 * @param {() => void} callback - The function to call when a click outside occurs.
 */
function useClickOutside(ref, callback) {
    useEffect(() => {
        const handleClickOutside = (event) => {
            const target = event.target 

            const overlayElement = document.querySelector('.routeYou_overlay');

            const isClickOnOverlay = overlayElement ? (target === overlayElement || overlayElement.contains(target)) : false;

            if (ref.current && !ref.current.contains(target) && !isClickOnOverlay) {
                callback();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, callback]); // Dependencies remain the same
}

export default useClickOutside;